import React, { Component, useContext } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import {TestHome} from './views/TestAPI';
import SolutionView from './views/SolutionView';
import { SolutionHome } from './views/SolutionsHome';
import NewOptimizationView from './views/NewOptimizationView';
import OptimizationHome from './views/OptimizationHome';
import { SingleOptimizationViewHOC } from './views/SingleOptimizationView';
import {useUserInfoContext} from './contexts/UserInfoContext';
import {UnauthorizedPage} from "./components/auth/Unauthorized";

import './custom.css'
import { AdminView } from './views/AdminView';
import { Loading } from './components/Loading';
import { UserManagementView } from './views/UserManagementView';
import Signup from './views/Signup';
import useDocumentTitle from './hooks/useDocumentTitle';
import HelpView from './views/HelpView';
// import { LoginHome } from './components/LoginHome';

export function App(props) {

  const {isLoading} = useUserInfoContext();
  useDocumentTitle("");
  
  if (isLoading){
    return (
      <Loading />
    )
  }


  return (
    <Layout>
      <Switch>
      <AuthorizedRoute exact path='/' component={OptimizationHome} />
      <AuthorizedRoute path='/schedule' component={SolutionView}/>
      <AuthorizedRoute path="/admin" component={AdminView}/>
      <AuthorizedRoute path="/optimizations" component={NewOptimizationView} />
      <AuthorizedRoute path="/settings" component={UserManagementView} />
      <AuthorizedRoute path="/optimization/view" component={SingleOptimizationViewHOC} />
      <Route path="/unauthorized" component={UnauthorizedPage}/>
      <Route path="/signup" component={Signup} />
      <Route path="/help" component={HelpView}/>
      {/* <AuthorizedRoute path="/scheduleHome" component={SolutionHome}/> Route to have all schedules */}
      </Switch>
    </Layout>
  );
}




const AuthorizedRoute = ({ component: Component, path, ...props }) => {
  const { isAuthorized } = useUserInfoContext();
  console.log(isAuthorized);


  return (
    <Route
      path={path}
      render={(props) =>
        isAuthorized ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/unauthorized", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

export default App
